var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editBox"},[(!_vm.btnHide)?_c('button',{staticClass:"closeBtn",on:{"click":function($event){return _vm.$emit('edit')}}},[(_vm.icon==='edit')?_c('iconEdit'):_c('iconSave')],1):_vm._e(),_c('div',{staticClass:"editBoxContent"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }